import { useLocation } from "react-router-dom";

export const useGetLastSegment = () => {
	const location = useLocation();

	const { pathname } = location;

	return pathname.split("/").filter(Boolean).pop();
};
